module.exports = __webpack_public_path__ + "img/numCard-8.4b31f573.svg";